package one.healthium.onboarding.navigation.screenDefinition

import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import one.healthium.onboarding.domain.screens.ScreenDefinition
import one.healthium.onboarding.domain.screens.ScreensGroupModel
import one.healthium.onboarding.ui.navigation.GlobalInputEventDelegate

interface ScreenGroupComponent : GlobalInputEventDelegate, WebNavigationOwner {
    val stack: Value<ChildStack<*, ScreenDefinitionChild>>
    val screenGroup: ScreensGroupModel

    fun onBackClicked()

    class ScreenDefinitionChild(val screenDefinition: ScreenDefinition)
}